import { render, staticRenderFns } from "./PageButtons.vue?vue&type=template&id=ef9c2032&scoped=true&"
import script from "./PageButtons.vue?vue&type=script&lang=js&"
export * from "./PageButtons.vue?vue&type=script&lang=js&"
import style0 from "./PageButtons.vue?vue&type=style&index=0&id=ef9c2032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c2032",
  null
  
)

export default component.exports